<div class="container-fluid p-0">
  <div class="carousel-container">
    <carousel [interval]="myInterval" [(activeSlide)]="activeSlideIndex" [showIndicators]="true" [noPause]="false"
      [isAnimated]="true">

      @for (slide of slides; track slide.photoURL; let i = $index) {
      <slide>
        <div class="carousel-image-wrapper">
          <img [src]="slide.photoURL" [alt]="'Banner image ' + (i + 1)" class="carousel-image" loading="lazy"
            decoding="async" />
        </div>
      </slide>
      }
    </carousel>
  </div>
</div>